import { render, staticRenderFns } from "./ImportStudentsDialog.vue?vue&type=template&id=0677a5ab"
import script from "./ImportStudentsDialog.vue?vue&type=script&lang=js"
export * from "./ImportStudentsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports